export default {
    primary: "#660033",
    headerText: "#ffcc99",
    sideBarText: "#cc9999",
    activeText: "white",
    overlayBackground: "#000",
    icon: "#fcd0b7"
};
